var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * @description The funciton accepts geolocation retruns the refined coordinates of roads.
 */
export var fetchDirections = function (start, end, wayPoints) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        wayPoints = wayPoints.map(function (item) {
            return {
                location: item
            };
        });
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var directionsService = new window.google.maps.DirectionsService();
                directionsService.route({
                    origin: start,
                    destination: end,
                    travelMode: window.google.maps.TravelMode.DRIVING,
                    waypoints: wayPoints,
                    optimizeWaypoints: true
                }, function (result, status) {
                    if (status === window.google.maps.DirectionsStatus.OK) {
                        resolve(result);
                    }
                    else {
                        reject(status);
                    }
                });
            })];
    });
}); };
/**
 * @description This function simplifies the google api response. And returns lat long
 */
export var getCordinatesFromDirectionResponse = function (directionsResponse) {
    var coordinates = [];
    if (directionsResponse && directionsResponse.routes && directionsResponse.routes.length > 0) {
        var route = directionsResponse.routes[0];
        var legs = route.legs;
        legs.forEach(function (leg) {
            var steps = leg.steps;
            steps.forEach(function (step) {
                var path = step.path;
                path.forEach(function (point) {
                    coordinates.push({
                        lat: Number(point.lat()),
                        lng: Number(point.lng())
                    });
                });
            });
        });
    }
    return coordinates;
};
export var getCurrentLocation = function () {
    return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(function (_ref) {
            var _a = _ref.coords, lat = _a.latitude, lng = _a.longitude;
            var pos = {
                lat: lat,
                lng: lng
            };
            resolve(pos);
        }, function (error) {
            console.error("error", error);
            alert("Geolocation is not enable by your browser.");
        });
    });
};
export var calculateTotalDistance = function (coordinates) {
    var totalDistance = 0;
    for (var i = 1; i < coordinates.length; i++) {
        var start = new google.maps.LatLng(coordinates[i - 1].lat, coordinates[i - 1].lng);
        var end = new google.maps.LatLng(coordinates[i].lat, coordinates[i].lng);
        totalDistance += google.maps.geometry.spherical.computeDistanceBetween(start, end);
    }
    return totalDistance; // Total distance in meters
};
